import React from 'react'
import { Button } from 'antd'

import Styles from './ExamineeInfoModal.module.scss'
import ChsiReportVerificationItemList from './ChsiReportVerificationItemList'
import {
  getChsiOverallSummaryDisplay,
  getChsiReportItems,
  shouldShowChsiDetailBtn,
  shouldShowChsiSummary
} from '../../common/chsiReportVerificationConstants'

function ChsiReportVerificationSummary (props) {
  const verification = props.verification

  if (!shouldShowChsiSummary(verification)) {
    return null
  }

  const { message, className } = getChsiOverallSummaryDisplay(verification)
  const items = getChsiReportItems(verification)
  const showLegacyDetail = items.length === 0 && shouldShowChsiDetailBtn(verification) && props.onViewDetail

  return (
    <div className={ `${ Styles.infoItem } ${ Styles.chsiVerificationItem }` }>
      <div className={ Styles.infoLabel }>学信网核验</div>
      <div className={ Styles.chsiVerificationWrap }>
        <div className={ `${ className } ${ Styles.chsiOverallSummary }` }>{ message }</div>
        <ChsiReportVerificationItemList
          items={ items }
          onViewDetail={ props.onViewDetail }
        />
        {
          showLegacyDetail
            ? (
              <Button
                type="link"
                size="small"
                className={ Styles.chsiLegacyDetailBtn }
                onClick={ () => props.onViewDetail(verification.chsiVerificationId) }
              >
                查看详情
              </Button>
            )
            : null
        }
      </div>
    </div>
  )
}

export default ChsiReportVerificationSummary
